"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const assert_1 = __importDefault(require("assert"));
const bn_js_1 = __importDefault(require("bn.js"));
const encUtils = __importStar(require("enc-utils"));
const js_sha3_1 = __importDefault(require("js-sha3"));
const oneBn = new bn_js_1.default('1', 16);
const shiftBN = new bn_js_1.default('10000000000000000000000000000000000000000000000000000000000000000', 16);
const mask = new bn_js_1.default('3ffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff', 16);
function getAssetType(assetDict) {
    const assetSelector = getAssetSelector(assetDict.type);
    let expectedLen = encUtils.removeHexPrefix(assetSelector).length;
    let assetInfo = new bn_js_1.default(encUtils.removeHexPrefix(assetSelector), 16);
    if (assetDict.data.tokenAddress !== undefined) {
        const tokenAddress = new bn_js_1.default(encUtils.removeHexPrefix(assetDict.data.tokenAddress), 16);
        assetInfo = assetInfo.mul(shiftBN);
        expectedLen += 64;
        assetInfo = assetInfo.add(tokenAddress);
    }
    const quantInfo = assetDict.data.quantum;
    const quantum = quantInfo === undefined ? oneBn : new bn_js_1.default(quantInfo, 10);
    assetInfo = assetInfo.mul(shiftBN);
    expectedLen += 64;
    assetInfo = assetInfo.add(quantum);
    let assetType = js_sha3_1.default.keccak_256(encUtils.hexToBuffer(addLeadingZeroes(assetInfo.toJSON(), expectedLen)));
    let assetTypeBN = new bn_js_1.default(assetType, 16);
    assetTypeBN = assetTypeBN.and(mask);
    return '0x' + assetTypeBN.toJSON();
}
exports.getAssetType = getAssetType;
function getAssetId(assetDict) {
    const assetType = new bn_js_1.default(encUtils.removeHexPrefix(getAssetType(assetDict)), 16);
    let assetId = assetType;
    if (assetDict.type === 'ERC721') {
        let tokenId = assetDict.data.tokenId;
        let assetInfo = new bn_js_1.default(encUtils.utf8ToBuffer('NFT:'), 16);
        assetInfo = assetInfo.mul(shiftBN);
        assetInfo = assetInfo.add(assetType);
        assetInfo = assetInfo.mul(shiftBN);
        assetInfo = assetInfo.add(new bn_js_1.default(parseInt(tokenId), 16));
        const expectedLen = 136;
        let assetIdHex = js_sha3_1.default.keccak_256(encUtils.hexToBuffer(addLeadingZeroes(assetInfo.toJSON(), expectedLen)));
        let assetIdBN = new bn_js_1.default(assetIdHex, 16);
        assetIdBN = assetIdBN.and(mask);
        return '0x' + assetIdBN.toJSON();
    }
    return '0x' + assetId.toJSON();
}
exports.getAssetId = getAssetId;
function getEthAssetId(quantum) {
    const asset = {
        type: 'ETH',
        data: {
            quantum,
        },
    };
    return getAssetId(asset);
}
exports.getEthAssetId = getEthAssetId;
function getErc20AssetId(tokenAddress, quantum) {
    const asset = {
        type: 'ERC20',
        data: {
            tokenAddress,
            quantum,
        },
    };
    return getAssetId(asset);
}
exports.getErc20AssetId = getErc20AssetId;
function getErc721AssetId(tokenAddress, tokenId) {
    const asset = {
        type: 'ERC721',
        data: {
            tokenAddress,
            tokenId,
        },
    };
    return getAssetId(asset);
}
exports.getErc721AssetId = getErc721AssetId;
function getAssetSelector(assetDictType) {
    let seed = '';
    switch (assetDictType.toUpperCase()) {
        case 'ETH':
            seed = 'ETH()';
            break;
        case 'ERC20':
            seed = 'ERC20Token(address)';
            break;
        case 'ERC721':
            seed = 'ERC721Token(address,uint256)';
            break;
        default:
            throw new Error(`Unknown token type: ${assetDictType}`);
    }
    return encUtils.sanitizeHex(js_sha3_1.default.keccak_256(seed).slice(0, 8));
}
exports.getAssetSelector = getAssetSelector;
function addLeadingZeroes(hexStr, expectedLen) {
    let res = hexStr;
    assert_1.default(res.length <= expectedLen);
    while (res.length < expectedLen) {
        res = '0' + res;
    }
    return res;
}
exports.addLeadingZeroes = addLeadingZeroes;
//# sourceMappingURL=asset.js.map